import { EnterpriseData } from '../../interfaces/enterprise/enterpriseData'
import CardPatrocinado from '../Cards/CardPatrocinado'
import BaseInfos from './BaseInfos'

import { Suspense, useEffect, useState } from 'react'
import SkeletonLoading from '../common/SkeletonLoading'
import Differentials from './Differentials'
import Location from './Location'
import Proximities from './Proximities'
import FichaTecnica from './FichaTecnica'
import Tour360 from './Tour360'
import FinancingConditions from './FinancingConditions'
import Fonte from './Fonte'
import LastPublish from './LastPublish'
import { AboutCompany } from './AboutCompany'
import CardPatrocinadoByIndex from '../Cards/CardPatrocinadoByIndex'
import { CardFormContactLead } from '../Cards/CardFormContactLead'
import CardBannerFair from '../Cards/CardBannerFair'
import { v4 } from 'uuid'

interface Props {
  enterprise: EnterpriseData
}

export default function SectionDetailsTest({ enterprise }: Props) {
  return (
    <div className="mt-10 lg:mt-5 lg:grid lg:gap-5">
      {/* <div className="my-5">
        <CardPatrocinadoByIndex
          position={1}
          enterpriseId={enterprise.Id}
          constructionCompanyId={enterprise.ConstructionCompanyId}
        />
      </div> */}
      <CardBannerFair enterpriseId={enterprise.Id} constructionCompanyId={enterprise.ConstructionCompanyId}/>
      <div className="grid gap-5 container-responsive-view-mob">
        {/* DESCRICAO  */}
        <div className="text-[#4D4D4D] border border-gray-200 rounded-xl p-4">
          <h3 className="fw-bold mb-3 text-lg">Descrição</h3>
          <p className="text-base text-[#575757] fw-normal">{enterprise.Description}</p>
        </div>
        {/* DIFERENCIAIS */}
        <Suspense fallback={<SkeletonLoading />}>
          <Differentials EnterpriseId={enterprise.Id} EnterpriseTitle={enterprise?.Title} />
        </Suspense>
      </div>
      {/* FORM LEAD   */}
      <div
        className="lg:hidden my-4 py-4"
        style={{ background: 'linear-gradient(90deg, #0163FF 0%, #01BCFD 100%)' }}
      >
        <div className='container-responsive-view'>
          <CardFormContactLead
            formId={v4()}
            btnBg='primary-gradient'
            constructionId={enterprise.ConstructionCompanyId ?? ''}
            enterpriseId={enterprise.Id ?? ''}
          />
        </div>
      </div>
      <div className="grid gap-5 container-responsive-view-mob">
        {/* LOCALIZAÇÃO */}
        <Suspense fallback={<SkeletonLoading />}>
          <Location EnterpriseId={enterprise.Id} />
        </Suspense>
        {/* PROXIMIDADES */}
        <Suspense fallback={<SkeletonLoading />}>
          <Proximities EnterpriseTitle={enterprise?.Title} EnterpriseId={enterprise?.Id} />
        </Suspense>
        {/* TOUR 360 */}
        <Suspense fallback={<SkeletonLoading />}>
          <Tour360 EnterpriseId={enterprise?.Id} />
        </Suspense>
        {/* CONDICOES DE FINANCIAMENTO  */}
        <Suspense fallback={<SkeletonLoading />}>
          <FinancingConditions EnterpriseId={enterprise.Id} />
        </Suspense>
        {/* FICHA TECNICA  */}
        <Suspense fallback={<SkeletonLoading />}>
          <FichaTecnica
            Title={enterprise?.Title}
            Realization={enterprise.ConstructionCompany}
            EnterpriseId={enterprise.Id}
          />
        </Suspense>
        {/* FONTE */}
        <Suspense fallback={<SkeletonLoading />}>
          <Fonte fonteUrl={enterprise.Url} />
        </Suspense>
        {/*DATA DE ATUALIZAÇÃO*/}
        <Suspense fallback={<SkeletonLoading />}>
          <LastPublish lastPublish={enterprise.LastPublish} />
        </Suspense>
        {/* SOBRE A EMPRESA  */}
        <Suspense fallback={<SkeletonLoading />}>
          <AboutCompany enterprise={enterprise} />
        </Suspense>
      </div>
    </div>
  )
}
